export enum DateTimeRangeTypes {
  LIFETIME = 'lifetime',
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  THIS_MONTH = 'thisMonth',
  LAST_MONTH = 'lastMonth',
  CUSTOM = 'custom',
  LAST_SEVEN_DAYS = 'lastSevenDays',
}
